import { useEffect } from 'react';
import { NavDropdown, NavItem } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { Dispatch } from 'redux';
import { ensureSelectedCompany } from '../../../actions/companyActions';

export default function HomeTopNav() {
  const dispatch: Dispatch<any> = useDispatch();
  const { companyId } = useParams<{ companyId?: string }>();

  useEffect(() => {
    if (companyId) {
      dispatch(ensureSelectedCompany(parseInt(companyId, 10)));
    }
  }, [companyId, dispatch]);

  return (
    <NavDropdown title="Action" id="nav-dropdown" className="nav-dropdown">
      <LinkContainer to="/">
        <NavItem>Home</NavItem>
      </LinkContainer>
    </NavDropdown>
  );
}
